import { random, round2Str } from "../helpers/helpers";
import { aqiMeterRegistry } from "./aqiMeterRegistry";

export const generateAqiIndoorLatestDashboardDemo = () => {
    const now = new Date();

    const formatLastSeen = (date) =>
        `${String(date.getDate()).padStart(2, "0")}-${date.toLocaleString(
            "default",
            { month: "short" }
        )}-${date.getFullYear().toString().slice(-2)} ${String(
            date.getHours()
        ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;

    const sensors = aqiMeterRegistry.map((meter) => {
        const { ranges } = meter;

        const lastSeen = new Date(now);
        lastSeen.setMinutes(now.getMinutes() - random(1, 5));

        return {
            meter_id: meter.meter_id,
            sensor_name: meter.meter_name,

            temperature: round2Str(
                random(ranges.temperature[0], ranges.temperature[1])
            ),
            humidity: round2Str(
                random(ranges.humidity[0], ranges.humidity[1])
            ),
            co: round2Str(random(ranges.co[0], ranges.co[1])),
            tvoc: round2Str(random(ranges.tvoc[0], ranges.tvoc[1])),
            formaldehyde: round2Str(
                random(
                    ranges.formaldehyde[0],
                    ranges.formaldehyde[1]
                )
            ),
            pm2: round2Str(random(ranges.pm2[0], ranges.pm2[1])),
            pm10: round2Str(random(ranges.pm10[0], ranges.pm10[1])),
            "is_co": true,
            "is_formaldehyde": true,
            "is_humidity": true,
            "is_pm10": true,
            "is_pm2": true,
            "is_temperature": true,
            "is_tvoc": true,
            status: "Online",
            last_seen: formatLastSeen(lastSeen),
        };
    });

    const active = sensors.filter((s) => s.status === "Online").length;

    return {
        total: sensors.length,
        active,
        inactive: sensors.length - active,
        sensors,
    };
};
